import React from 'react';

import './style.css';

const BlurBox = () => {
  return <div id="blur-box"></div>;
};

export default BlurBox;
